export const environment = {
  production: false,
  host: 'https://api-test.jared.finance/api',
  uploaderHost: 'https://upload-test.jared.finance/api/upload',
  imagesBasePath: 'https://upload-test.jared.finance/storage',
  uploadSize: 3
}
